import { useApi, configApiRef } from '@backstage/core-plugin-api';

export const useGetAPI = () => {
  const config = useApi(configApiRef);
  const url =
    config.getOptionalString('app.apiUrl') ??
    'https://devportal-api.dev.acuitynext.io';

  return url;
};
